import isValidEmail from 'shared/helpers/is-valid-email';
import isValidUrl from 'shared/helpers/is-valid-url';
import {
  assert,
  isNotNull,
  isString,
  isNotEmptyString,
  isMinimumLength,
  isNotOneOf,
  isNot,
  emptyOr,
} from '../validators';

export const EMPTY_DESCRIPTION_PERMUTATIONS = [
  '',
  '<p></p>',
  '<p><br></p>',
  '<div></div>',
  '<div><br></div>',
  '<div><p></p></div>',
];

export default {
  image: [assert(isNotNull, 'Missing image'), assert(isNotEmptyString, 'Missing image')],
  name: [
    assert(isString, 'Invalid type'),
    assert(isNotEmptyString, 'This field is required and cannot be empty'),
    assert(isMinimumLength(2), 'Has to be at least three (3) characters long'),
    assert(isNot('Untitled Show'), 'Not a valid name'),
  ],
  description: [
    assert(isString, 'Invalid type'),
    assert(isNotEmptyString, 'This field is required and cannot be empty'),
    assert(
      isNotOneOf(EMPTY_DESCRIPTION_PERMUTATIONS),
      'This field is required and cannot be empty'
    ),
  ],
  'rss.subtitle': [
    assert(isString, 'Invalid type'),
    assert(isNotEmptyString, 'This field is required and cannot be empty'),
  ],
  'rss.summary': [
    assert(isString, 'Invalid type'),
    assert(isNotEmptyString, 'This field is required and cannot be empty'),
  ],
  'rss.author': [
    assert(isString, 'Invalid type'),
    assert(isNotEmptyString, 'This field is required and cannot be empty'),
  ],
  'rss.ownerEmail': [
    assert(isString, 'Invalid type'),
    assert(isNotEmptyString, 'This field is required and cannot be empty'),
    assert(isValidEmail, 'Not a valid email address'),
  ],
  // Not required
  homepage: [assert(emptyOr(isValidUrl), 'This is not a valid URL')],
};
